import 'babel-polyfill';
import 'transitionEnd';
import promiseFinally from 'promise.prototype.finally';
import SHSignals from 'sh-signals';
import SpotHero from 'spothero'; // eslint-disable-line no-unused-vars
import Desktop from 'desktop';

promiseFinally.shim();

SHSignals.pageInitialized.add((pageName, initData) => {
    switch (pageName) {
        case 'desktop':
            Desktop.init();
            break;
    }
});



// WEBPACK FOOTER //
// ./spothero/static/main/js/modules/main-desktop.js